import { IconBolt } from '../../../components/Icons.jsx'

/**
 * Top “chiron” / promo ribbon for founding-member pricing.
 * Homepage only (mounted from HomePage).
 */
export function FoundingMembersBanner() {
  return (
    <div
      className="relative z-40 border-b border-plum-700/30 px-4 py-2.5 text-center text-white"
      style={{ background: 'linear-gradient(90deg,#4a0e35,#721A55 50%,#93276e)' }}
      role="status"
    >
      <p className="mx-auto max-w-[920px] font-display text-[12.5px] font-bold leading-snug tracking-wide text-white sm:text-[13.5px]">
        {/* An icon, not the ⚡ emoji: drawing the emoji meant loading the system
            colour-emoji font during first layout, before the page could paint. */}
        <IconBolt
          size="1.15em"
          fill="#FFD43B"
          stroke="#F59F00"
          aria-hidden="true"
          style={{ display: 'inline', verticalAlign: '-0.2em' }}
        />{' '}
        First 1,000 Members Lock In{' '}
        <span className="text-[#E4EA93]">$133/Month Semaglutide</span> or{' '}
        <span className="text-[#E4EA93]">$166/Month Tirzepatide</span> for 3 Months — All Labs,
        Prescriptions &amp; Any Dose Included. Once They&rsquo;re Gone, This Price Is Gone.
      </p>
    </div>
  )
}
